import { render, staticRenderFns } from "./PopupForm.vue?vue&type=template&id=46778c1e&scoped=true"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"
import style0 from "./PopupForm.vue?vue&type=style&index=0&id=46778c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46778c1e",
  null
  
)

export default component.exports